import React from "react"
import { Route } from "react-router-dom"

import PageNotFound from "./components/PageNotFound"

export default {
  routes: [<Route path="*" key="pageNotFound" component={PageNotFound} />],
}
